var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"copyrightPassport",style:([_vm.styles]),domProps:{"innerHTML":_vm._s(_vm.copyright)}})
}
var staticRenderFns = []

export { render, staticRenderFns }